import { render, staticRenderFns } from "./RegionDetailView.vue?vue&type=template&id=6ff18966&lang=pug"
import script from "./RegionDetailView.vue?vue&type=script&lang=js"
export * from "./RegionDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports